// utils/ThemeContext.js
import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        // Load from localStorage or default to 'light'
        return localStorage.getItem('quizacer-theme') || 'light';
    });

    useEffect(() => {
        // Apply theme class to body
        document.body.classList.remove('light', 'dark');
        document.body.classList.add(theme);
        localStorage.setItem('quizacer-theme', theme);
    }, [theme]);

    const toggleTheme = (newTheme) => {
        setTheme(newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};